export default __webpack_public_path__ + "static/top_sp-1762572754f94d6880edbca007ddaaa8.png";